import React, { ElementType, ReactElement, ReactNode } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'

export default function FeatureUseCasesItem({
  image,
  title,
  subText,
}: {
  image: ElementType
  title: string
  subText: string | ReactNode
}): ReactElement {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        borderRadius: '1.2rem',
        pt: ['1.6rem', '2.4rem'],
        pb: ['3.2rem', '4.8rem'],
        px: ['1.6rem', '2.4rem'],
        alignItems: 'center',
        backgroundColor: 'blueYonder5',
        border: '1px solid',
        borderColor: 'borderFaint',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: ['1.6rem', '2.4rem'],
        }}
      >
        <Flex sx={{ width: '100%', justifyContent: 'center' }}>
          <Svg
            svg={image}
            sx={{ display: 'flex', width: '100%', height: 'auto' }}
            descriptiveText={`Illustration for ${title} use case`}
          />
        </Flex>
        <Flex
          sx={{
            flexDirection: 'column',
            maxWidth: '43.7rem',
            gap: '0.8rem',
            textAlign: 'left',
          }}
        >
          <Text
            variant="size19Weight600Line138"
            sx={{
              color: 'aliceBlue',
            }}
          >
            {title}
          </Text>
          <Text
            variant="size16Weight400Line140"
            sx={{
              color: 'wildBlueYonder',
            }}
          >
            {subText}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
